// extracted by mini-css-extract-plugin
module.exports = {"PostsListViewContainer":"List_PostsListViewContainer__fWFEz"};